import storageService from '../storageService';
import {CallRecordingService} from './restServices';

const service = {};

service.startCallRecording = async (
  sessionInstanceId,
  otSessionId,
  chatRoomId,
) => {
  const response = await CallRecordingService.update(
    {
      endpoint: 'start',
    },
    {
      sessionInstanceId,
      chatRoomId,
      token: storageService.getItem('token'),
    },
  );

  return response.data;
};

service.stopCallRecording = async (callRecordingId) => {
  await CallRecordingService.update(
    {
      endpoint: 'stop',
    },
    {
      callRecordingId,
      token: storageService.getItem('token'),
    },
  );
};

service.getCallRecordingByCallRecordingId = async (callRecordingId) => {
  const response = await CallRecordingService.get(
    {
      endpoint: 'stream/byCallRecordingId',
      endpointParam: callRecordingId,
    },
    {token: storageService.getItem('token')},
  );

  return response.data?.callRecordingDto;
};

service.deleteCallRecordingByCallRecordingId = async (callRecordingId) => {
  const response = await CallRecordingService.delete(
    {
      endpoint: 'byCallRecordingId',
      endpointParam: callRecordingId,
      token: storageService.getItem('token'),
    },
    {token: storageService.getItem('token')},
  );

  return response?.data;
};

service.sendCallRecordingLinkByEmail = async (requestObj) => {
  const response = await CallRecordingService.save(
    {
      endpoint: 'sendEmail',
    },
    {
      token: storageService.getItem('token'),
      ...requestObj,
    },
  );
  return response.data;
};

const callRecordingService = {...service};
export default callRecordingService;
